var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finding)?_c('v-container',{staticClass:"px-6 mt-0",attrs:{"fluid":""}},[(_vm.finding)?_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{},[_c('Finding',{attrs:{"finding":_vm.finding},scopedSlots:_vm._u([{key:"proposed",fn:function(ref){
var finding = ref.finding;
return [_vm._t("proposed",null,{"finding":finding})]}},{key:"cas",fn:function(ref){
var finding = ref.finding;
return [_vm._t("cas",null,{"finding":finding})]}},{key:"notes",fn:function(ref){
var finding = ref.finding;
return [_vm._t("notes",null,{"finding":finding})]}}],null,true)})],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }